import { getTemplatePage } from "../../../data/models/page.model";
import { getItemsList } from "../../../data/models/collection.model";
import { bus } from "@/main";


export default {
	name: "ApplyPage",
	data() {
		return {
			content: [],
			items: [],
			url: window.location.href
		}
	},
	props: {},
	created() {
		this.getContent();
	},
	watch: {
		"$route": function() {
			this.url = window.location.href;
			this.getContent();
		}
	},
	mounted() {
		setTimeout(() => {
			bus.$emit("evalColors", true);
		}, 200);
	},
	computed: {
	},
	methods: {
		getContent(){
			let contentReady = new Promise((resolve, reject) => {
				getTemplatePage('pages/about-page.php').then(
					content => {
						this.content = content
						this.isReady = true
						bus.$emit("evalColors", true);
						bus.$emit("PAGE_IS_READY", true);
					}
				)
			})
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/about/about.page.js